var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b2f54f5c-2fc4-462a-92f7-5e377fbf42f9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "header_user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM4.05,16.73a6.59,6.59,0,0,1,11.75.14,8.95,8.95,0,0,1-11.75-.14Zm5.84-5A3.19,3.19,0,1,1,13.08,8.5,3.19,3.19,0,0,1,9.89,11.69Zm6.65,4.47a7.63,7.63,0,0,0-5.09-3.78,4.19,4.19,0,1,0-3.13,0,7.53,7.53,0,0,0-5,3.63,9,9,0,1,1,13.22.15Z",
    fill: "#485b6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b45b44b5718134a11d845b433d7d1207.svg";
export { ForwardRef as ReactComponent };